import { render, staticRenderFns } from "./DynamicTextPrefills.vue?vue&type=template&id=0c8fddb0"
import script from "./DynamicTextPrefills.vue?vue&type=script&lang=js"
export * from "./DynamicTextPrefills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports